import { useField, useFormikContext } from "formik";
import { forwardRef } from "react";
import cn from "../../../lib/cn";
import P from "../../typography/P";

const FormikLabeledInput = forwardRef(
    (
        {
            label,
            required,
            errorMessage,
            labelClass,
            className,
            value,
            onChange = () => {},
            wrapperClassName,
            icon,
            iconChange,
            iconWrapperClass,
            helperMsg,
            disabled,
            ...rest
        },
        ref
    ) => {
        const [field, meta, helpers] = useField(rest);
        const { setTouched } = useFormikContext();
        const handleChange = (e) => {
            const val = e.target.value;
            helpers.setValue(val);

            setTouched({ [field.name]: true });
            if (typeof onChange === "function") {
                onChange(e);
            }
        };

        const inputProps = {
            ...rest,
            name: field.name,
            value: typeof value !== "undefined" ? value : field.value,
            onKeyUp: handleChange,
            onChange: field.onChange,
            disabled,
        };
        return (
            <div className={cn("mb-2 2xl:mb-3.2", wrapperClassName)}>
                <div
                    className={cn(
                        "relative border border-blue-50 rounded-sm px-2 py-1.5 md:py-1.5 focus-within:border-blue duration-300 box-border",

                        className,
                        {
                            "border-red":
                                (meta.error && meta.touched) || errorMessage,
                        }
                    )}
                >
                    {label && (
                        <label
                            htmlFor={field.name}
                            className={cn(
                                "text-xs lg:text-sm font-urbanist absolute left-1.8 -top-1 bg-white px-0.8 flex items-center gap-0.5",
                                labelClass
                            )}
                        >
                            {label}{" "}
                            {required && <span className="text-red">*</span>}
                        </label>
                    )}
                    <input
                        type="text"
                        className={cn(
                            `text-sm lg:text-base text-gray-secondary placeholder:text-gray-550 border-none outline-none h-full w-full transition-all duration-300 font-vietnam font-light`,
                            {
                                "pr-3.8 lg:pr-5 ": icon,
                            }
                        )}
                        {...inputProps}
                        ref={ref}
                    />
                    {icon && (
                        <div
                            className={cn(
                                `cursor-pointer absolute right-0 top-0 h-full px-1 lg:px-2 flex   items-center justify-center  text-gray-550 text-2xl `,
                                iconWrapperClass
                            )}
                        >
                            <span
                                onClick={() => iconChange()}
                                className={` cursor-pointer   items-center`}
                            >
                                {icon}
                            </span>
                        </div>
                    )}
                </div>
                {meta.error && meta.touched && (
                    <P className="text-red text-xs mt-0.4">{meta.error}</P>
                )}
                {errorMessage && !meta.error && (
                    <P className="mt-0.4 text-red text-xs flex flex-col gap-0.5 items-start">
                        {errorMessage}
                    </P>
                )}
                {helperMsg && (
                    <P className="text-gray-600 text-xs md:text-xs xl:text-sm mt-0.4">
                        {helperMsg}
                    </P>
                )}
            </div>
        );
    }
);

export default FormikLabeledInput;
